'use client';

import { PageMain } from '@/app/(app)/page-main';

import { CreateServiceTypeTemplateDialog } from './dialog';
import { ServicePlanTemplatesTable } from './table/table';

export function ServicePlansPage() {
  return (
    <PageMain title='Subscriptions'>
      <div className='flex w-full items-center justify-between'>
        <div className='flex flex-col gap-0.5'>
          <h1 className='text-heading-lg'>Subscriptions</h1>
          <p className='text-sm text-muted-foreground'>Manage your subscriptions.</p>
        </div>
        <CreateServiceTypeTemplateDialog />
      </div>
      <ServicePlanTemplatesTable />
    </PageMain>
  );
}
